'use client';

import Image from 'next/image';

import { findShop } from '~/utils/shop-service';

import styles from './ShopBanner.module.css';
type Props = {
  shopId: string;
};
export const ShopBanner = ({ shopId }: Props) => {
  const shop = findShop(shopId);
  return (
    <div className={styles.container}>
      {shop && (
        <Image
          src={shop.images.topBanner}
          width={375}
          height={150}
          priority
          unoptimized
          alt={`${shop.shopNameKor} 탑 배너`}
        />
      )}
    </div>
  );
};
